import { render, staticRenderFns } from "./VentilationSystem.vue?vue&type=template&id=96a832de"
import script from "./VentilationSystem.vue?vue&type=script&lang=js"
export * from "./VentilationSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports